module.exports = __webpack_public_path__ + "img/9788961700962.74c2090f.jpg";